<div [class]="'container px-2 pb-3 main-container ' + (reservationListFontSize | fontSizeClass)">
    <!-- toolbar -->
    <div class="d-flex align-items-center">

        <!-- toggle filters button -->
        <button class="btn-toggler btn-filters-toggle" data-bs-toggle="collapse" data-target="#filters" href="#filters"
            aria-expanded="false">
            <span *ngIf="getSelectedFiltersNumber() > 0" class="badge-count">{{getSelectedFiltersNumber()}}</span>
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <style>
                        .cls-1 {
                            fill: none;
                        }
                    </style>
                </defs>

                <g data-name="Layer 2" id="Layer_2">
                    <path d="M28,9H11a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z" />
                    <path d="M7,9H4A1,1,0,0,1,4,7H7A1,1,0,0,1,7,9Z" />
                    <path d="M21,17H4a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z" />
                    <path d="M11,25H4a1,1,0,0,1,0-2h7a1,1,0,0,1,0,2Z" />
                    <path d="M9,11a3,3,0,1,1,3-3A3,3,0,0,1,9,11ZM9,7a1,1,0,1,0,1,1A1,1,0,0,0,9,7Z" />
                    <path d="M23,19a3,3,0,1,1,3-3A3,3,0,0,1,23,19Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,23,15Z" />
                    <path d="M13,27a3,3,0,1,1,3-3A3,3,0,0,1,13,27Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,13,23Z" />
                    <path d="M28,17H25a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Z" />
                    <path d="M28,25H15a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z" />
                </g>
                <g id="frame">
                    <rect class="cls-1" height="32" width="32" />
                </g>
            </svg>
        </button>

        <!-- search -->
        <form *ngIf="(restaurantName$ | async) as restaurantName"
            class="position-relative search-component ml-sm-2 pr-2">
            <!-- <div class="search-container">
                <input class="ihost-control w-100" type="search" name="SearchTerm" [(ngModel)]="searchTerm" placeholder="{{'reservations.list.search' | translate}}...">
                <button *ngIf="searchTerm != null && searchTerm.length > 0" class="btn-clear" type="button" (click)="searchTerm = ''">&times;</button>
            </div> -->
            <ng-container *ngIf="!(isOffline$ | async)">
                <div [canWrite]="'SearchReservation'" class="search-container global-search">
                    <input class="ihost-control" type="search" name="SearchTerm" placeholder="{{restaurantName}}..."
                        [(ngModel)]="searchTerm" (change)="setGlobalSearchTerm($event)" autocomplete="off"
                        autocorrect="off">

                    <button *ngIf="searchTerm != null && searchTerm.length > 0" class="btn-clear" type="button"
                        (click)="searchTerm = ''">&times;</button>
                </div>
                <a [canWrite]="'SearchReservation'" class="btn btn-sm btn-main px-2 ms-2 me-2"
                    [routerLink]="['/reservations/search']">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-search" viewBox="0 0 16 16">
                        <path
                            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                    </svg>
                </a>
                <span *ngIf="!canSearchReservation()">{{restaurantName}}</span>
            </ng-container>
        </form>

        <!-- sort by -->
        <div id="table-view-cycle" class="d-flex justify-content-end align-items-center dropdown ihost-dropdown ms-auto">
            <div class="sort-reservations me-2">
                <app-dropdown *ngIf="sortTypes != null &&  sortTypes.length > 0" [model]="sortType"
                    (modelChange)="setSortType($event)" [items]="sortTypes" [displayProperty]="'display'"
                    [valueProperty]="'value'" [inlineLabel]="'reservations.list.sortBy' | translate">
                </app-dropdown>
            </div>
            <a class="btn btn-sm btn-main px-2" (click)="toggleSorting()">
                <svg *ngIf="sortDesc" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-sort-down" viewBox="0 0 16 16">
                    <path
                        d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z" />
                </svg>
                <svg *ngIf="!sortDesc" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-sort-up" viewBox="0 0 16 16">
                    <path
                        d="M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z" />
                </svg>
            </a>
        </div>
    </div>

    <!-- filters -->
    <div id="filters" class="collapse">
        <div class="btn-filter-group pt-3">
            <!-- <a class="btn btn-xs btn-filter-pill" [class.active]="compactView"
                (click)="toggleCompactView()">{{'reservations.list.compactView' |
                translate}}</a> -->
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.groupByStatus == true"
                (click)="setFilters({ groupByStatus: !filters.groupByStatus })">{{'reservations.list.groupByStatus' |
                translate}}</a>
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withDietary == true"
                (click)="setFilters({ withDietary: !filters.withDietary })">{{'reservations.list.withDietary' |
                translate}}</a>
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withType == true"
                (click)="setFilters({ withType: !filters.withType })">{{'reservations.list.withType' |
                translate}}</a>
            <!-- <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withResvTags == true"
                (click)="setFilters({ withResvTags: !filters.withResvTags })">{{'reservations.list.withResvTags' |
                translate}}</a> -->
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withNotes == true"
                (click)="setFilters({ withNotes: !filters.withNotes })">{{'reservations.list.withNotes' |
                translate}}</a>
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withCake == true"
                (click)="setFilters({ withCake: !filters.withCake })">{{'reservations.list.withCake' |
                translate}}</a>
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withSource == true"
                (click)="setFilters({ withSource: !filters.withSource })">{{'reservations.list.withSource' |
                translate}}</a>
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withDiscount == true"
                (click)="setFilters({ withDiscount: !filters.withDiscount })">{{'reservations.list.withDiscount' |
                translate}}</a>
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withBill == true"
                (click)="setFilters({ withBill: !filters.withBill })">{{'reservations.list.withBill' | translate}}</a>
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withTokenization == true"
                (click)="setFilters({ withTokenization: !filters.withTokenization })">{{'reservations.list.withTokenization'
                |
                translate}}</a>
            <!--<a class="btn btn-xs btn-filter-pill" [class.active]="filters.withDeposit == true"
                (click)="setFilters({ withDeposit: !filters.withDeposit })">{{'reservations.list.withDeposit' |
                translate}}</a>-->
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withFood == true"
                (click)="setFilters({ withFood: !filters.withFood })">{{'reservations.list.withFood' |
                translate}}</a>
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.withDrink == true"
                (click)="setFilters({ withDrink: !filters.withDrink })">{{'reservations.list.withDrink' |
                translate}}</a>
            @if (restaurantHasOnlineCategories && filters.reservationCategories != null) {
            @for (onlineCategory of visibleOnlineCategories; track onlineCategory.id) {
            @if (onlineCategory.iconCaption != null && onlineCategory.iconCaption.length > 0) {
            <a class="btn btn-xs btn-filter-pill" [class.active]="filters.reservationCategories.indexOf(onlineCategory.id) >= 0"
                (click)="toggleCategoryFilter(onlineCategory)">{{onlineCategory.iconCaption}}</a>
            }
            }
            }
            <a class="btn btn-xs btn-clear-filter-pill" [class.disabled]="getSelectedFiltersNumber() <= 0"
                (click)="resetFilters()">{{'reservations.list.resetAll' | translate}}</a>
        </div>
    </div>
</div>

<div *ngIf="(processedShifts$ | async) as shifts" [class]="'container mt-2 pb-5 ' + (reservationListFontSize | fontSizeClass)">

    <!-- filters -->
    <ul class="nav btn-tab-group btn-tab-counts ps-3 pe-2">
        <li *ngFor="let shift of shifts" class="nav-item">
            <a class="nav-link btn-tab" [class.active]="selectedShift != null && selectedShift.shiftId == shift.shiftId"
                (click)="selectShift(shift)">{{getShiftTitle(shift.type)}}</a>
        </li>

        <!-- info -->
        <li [canRead]="'Total_Upcoming'" class="counts res-counts ms-auto text-sm">
            P <span
                class="text-link text-normal">{{blocking.pendingCovers}}</span>/{{blocking.totalCovers}}&nbsp;&nbsp;R
            <span class="text-link text-normal">{{blocking.pendingRes}}</span>/{{blocking.totalRes}}
        </li>

        <!-- quick change availability-->
        <li [canWrite]="'QuickCloseAvailability'" class="availability-btn">
            <a style="padding-left: 5px;padding-right: 5px;" class="btn btn-sm btn-main ms-3 d-flex align-items-center"
                (click)="showManageAvailability()">
                <img src="assets/images/online_availability.png" width="20" height="20">
            </a>
        </li>

        <li class="compact-view-toggle" [class.has-availability-btn]="showAvailabilityButton">
            <div class="form-check form-switch">
                <label class="form-check-label" for="flexSwitchCheckCompactView">{{'reservations.list.extraInfo' | translate}}</label>
                <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckCompactView" [checked]="!compactView" (change)="toggleCompactView()">
            </div>
        </li>
        
        <li class="today-btn">
            <a class="align-items-center btn btn-sm btn-main" [class.selected]="isTodaySelected()" (click)="today()">{{ 'common.today' | translate }}</a>
        </li>
    </ul>

    <!-- list -->
    <div class="tab-content">
        <div class="tab-pane fade show active" id="sample-tab-1" role="tabpanel">
            <table *ngIf="(reservations$ | async) as reservations"
                class="list-table-item list-table-link time-view mt-8">
                <ng-container *ngIf="!compactView">
                    <tbody app-reservation-list-item [reservation]="reservation" [index]="i" [isOffline]="isOffline"
                        *ngFor="let reservation of filteredReservations | sort:'reservationDetails.reservationsStatus':!filters.groupByStatus:sortReservations:initReservationsSorting:sortType:sortDesc; let i = index"
                        data-bs-toggle="collapse" [attr.href]="'#tr-' + i" aria-expanded="false"
                        [attr.aria-controls]="'tr-' + i" (click)="toggleReservation(reservation)">
                    </tbody>
                </ng-container>
                <ng-container *ngIf="compactView">
                    <!-- <thead>
                        <tr>
                            <th [canRead]="'Status'" class="td-status-c"></th>
                            <th *ngIf="canReadCustomer()" class="td-customer-c">{{ 'reservations.list.surname' |
                                translate }}</th>
                            <th [canRead]="'Covers'" class="td-covers-c">{{ 'reservations.list.covers' | translate }}
                            </th>
                            <th [canRead]="'ArrivalDateTime'" class="td-arrival-time-c">{{ 'reservations.list.arrival' |
                                translate }}</th>
                            <th [canRead]="'Table'" class="td-table-c">{{ 'reservations.list.table' | translate }}</th>
                            <th [canRead]="'Notes'" class="td-notes-c">{{ 'reservations.list.notes' | translate }}</th>
                            <th [canRead]="'FixMenu'" class="td-extra-info-c">{{ 'reservations.list.extraInfo' |
                                translate }}</th>
                            <th class="td-info-c">{{ 'reservations.list.details' | translate }}</th>
                            <th [canRead]="'Telephone'" class="td-phone-c">{{ 'reservations.list.phone' | translate }}
                            </th>
                            <th class="td-navigate-c"></th>
                        </tr>
                    </thead> -->
                    <tbody app-compact-reservation-list-item [reservation]="reservation" [index]="i"
                        [isOffline]="isOffline"
                        *ngFor="let reservation of filteredReservations | sort:'reservationDetails.reservationsStatus':!filters.groupByStatus:sortReservations:initReservationsSorting:sortType:sortDesc; let i = index"
                        data-bs-toggle="collapse" [attr.href]="'#tr-' + i" aria-expanded="false"
                        [attr.aria-controls]="'tr-' + i" (click)="toggleReservation(reservation)">
                    </tbody>
                </ng-container>
            </table>
        </div>
    </div>
</div>

<!-- status modal -->
<app-reservation-status-modal></app-reservation-status-modal>

<!-- manage availability modal -->
<app-modal-dialog #manageAvailabilityModal [static]="false" title="{{'manageAvailability.title' | translate }}"
    [modalId]="'availability-modal'" [hasCancel]="false" [hasClose]="true" [hasOk]="false">
    <div class="form-col">
        <h3> {{workingDateName | translate }}  {{workingDate}}</h3>

          <div class="custom-checkbox-body" [hidden]="errorMessage">
            <div class="custom-checkbox">
                <input [(ngModel)]="isDayAvailable" [ngModelOptions]="{standalone: true}" (change)="onlineAvailabilityChange($event)" id="status"
                       type="checkbox"
                       name="status"
                       role="switch">
                <label for="status">
                  <div class="status-switch"
                  [attr.data-unchecked]="uncheckedLabel"
                  [attr.data-checked]="checkedLabel">
                  </div>
                </label>
              </div>
          </div>

          <div *ngIf="errorMessage" class="error-label" role="alert">{{ errorMessage }}</div>
          <div *ngIf="successMessage" class="success-label" role="alert">{{ successMessage }}</div>
    </div>
</app-modal-dialog>